/**
 * Ten plik obsługuje ładowanie funkcji renderujących szablony
 */


// region ładowanie funkcji renderujących z vue, tu muszą być wszystkie wykorzystywane przez funkcje renderujące szablony
import {
    createTextVNode,
    createCommentVNode,
    createElementBlock,
    createBlock,
    createElementVNode,
    createSlots,
    createStaticVNode,
    createVNode,
    resolveComponent,
    resolveDirective,
    openBlock,
    withDirectives,
    withCtx,
    withScopeId,
    withModifiers,
    normalizeClass,
    Fragment,
    toDisplayString,
    renderList,
    vShow,
    vModelText,
    normalizeStyle,
    vModelRadio,
    vModelCheckbox,
    vModelSelect,
    resolveDynamicComponent,
    mergeProps,
    normalizeProps,
    setBlockTracking
}  from 'vue';
import {getEnv} from "@/utilities/env";
import {Deferred} from "@/serviceWorker/workerComponents/Utilities/Deferred";
import {getTranslation} from "@/utilities/translations";
import {backendFetch} from "@/services/NfBackendFetch";
const Vue = {
    createTextVNode,
    createCommentVNode,
    createElementBlock,
    createBlock,
    createElementVNode,
    createSlots,
    createStaticVNode,
    createVNode,
    resolveComponent,
    resolveDirective,
    openBlock,
    withDirectives,
    withCtx,
    withScopeId,
    withModifiers,
    normalizeClass,
    Fragment,
    toDisplayString,
    renderList,
    vShow,
    vModelText,
    normalizeStyle,
    vModelRadio,
    vModelCheckbox,
    vModelSelect,
    resolveDynamicComponent,
    mergeProps,
    normalizeProps,
    setBlockTracking
};
//endregion

var templatePromises: {[templateName:string]: Promise<Function|null>} = {
};

var widgetIdPromise = new Deferred<number>();

export function setWidgetId(widgetId: number) {
    if(!widgetIdPromise.isResolved()) {
        widgetIdPromise.resolve(widgetId);
    }
}
/**
 * Ta funkcja będzie próbowała załadować funkcję renderującą szablon komponentu
 * Poczeka na id widgeta zanim faktycznie zacznie ładować
 * @param templateName
 * @protected
 */
export async function loadTemplateRenderFunction(templateName: string, asCustomElement = false): Promise<Function|null> {
    // @ts-ignore
    if(templatePromises[templateName]) {
        return templatePromises[templateName];
    }

    const templateDefer = new Deferred<Function|null>();
    templatePromises[templateName] = templateDefer.promise;

    const widgetId = await widgetIdPromise.promise;
    if(!window.nfHotelSkipTemplateIdsFetching) {

        if (!window.nfHotelTemplateIdsPromise) {
            window.nfHotelTemplateIdsPromise = backendFetch(widgetId,  'widget_templates').then((response) => {
                return response.json().then(r => r.templates);
            });
        }
        try {
            const templateIds = <typeof window['nfHotelTemplates']>await window.nfHotelTemplateIdsPromise;
            window.nfHotelTemplates = Object.assign(templateIds || {}, window.nfHotelTemplates || {});
            window.localStorage.setItem('nfHotelTemplates', JSON.stringify(templateIds));
        } catch (ignore) {
            //Jeśli coś wywali ładowanie idków szablonów, to modlimy się że zostały już ustawione w zmiennej globalnej window.nfHotelTemplates
            const storedNfHotelTemplates = window.localStorage.getItem('nfHotelTemplates');
            if (storedNfHotelTemplates) {
                window.nfHotelTemplates = Object.assign(window.nfHotelTemplates || {},JSON.parse(storedNfHotelTemplates));
            }

        }
    }
    // @ts-ignore
    const templateId:number  =isFinite(templateName)?parseInt(templateName):window.nfHotelTemplates[templateName];
    if(templateId) {
        let renderFunctionCode: string;
        try {
            const templateFetch = await fetch(getEnv('VITE_RENDERED_FUNCTIONS_URL') + 'template_'+templateId+(asCustomElement?'-custom-element':'')+'.js');
            renderFunctionCode = await templateFetch.text();
            renderFunctionCode = 'window.nfShowDebugMessages && console.error("template script ' + templateId + '"); ' + renderFunctionCode;
        } catch (e) {
            console.error(`Error while downloading render function for template ${templateName}`,e);
            templateDefer.reject(`Error while downloading render function for template ${templateName}`);
            return null;
        }
        try {
            const renderFunction = (new Function('Vue', 'translate', renderFunctionCode)(Vue, getTranslation));
            renderFunction._rc = true;
            templateDefer.resolve(renderFunction);
            return renderFunction;
        } catch(e) {
            console.error(`Error while generating render function for template ${templateName} in function ${renderFunctionCode}`,e);
            templateDefer.reject(`Error while generating render function for template ${templateName} in function ${renderFunctionCode}`);
            return null;
        }
    } else {
        console.error('Nie znaleziono id szablonu dla nazwy '+templateName);
        templateDefer.reject('Nie znaleziono id szablonu dla nazwy '+templateName);
        return null;
    }
}
